module.exports = __webpack_public_path__ + "media/images/tmp/outfit-cef3605651d11a27aabdd665b69aded5.png";